(()=>{
 const root=document.querySelector('[data-locale-root]');
 if(!root)return;
 const CHOSEN='nl-locale-chosen',AUTO='nl-locale-auto';
 const store={get:(s,k)=>{try{return s.getItem(k)}catch(e){return null}},set:(s,k,v)=>{try{s.setItem(k,v)}catch(e){}}};

 // Dropdowns
 const groups=[...root.querySelectorAll('.nl-locale-group')];
 function close(group,focus){const t=group.querySelector('.nl-locale-trigger');t.setAttribute('aria-expanded','false');group.querySelector('.nl-locale-menu').hidden=true;if(focus)t.focus()}
 groups.forEach(group=>{
  const trigger=group.querySelector('.nl-locale-trigger'),menu=group.querySelector('.nl-locale-menu');
  trigger.addEventListener('click',()=>{const open=trigger.getAttribute('aria-expanded')!=='true';groups.forEach(g=>close(g));trigger.setAttribute('aria-expanded',String(open));menu.hidden=!open;if(open)(menu.querySelector('[aria-current=true]')||menu.querySelector('button')).focus()});
  menu.addEventListener('keydown',e=>{if(e.key!=='ArrowDown'&&e.key!=='ArrowUp')return;e.preventDefault();const items=[...menu.querySelectorAll('button')],i=items.indexOf(document.activeElement);items[(i+(e.key==='ArrowDown'?1:-1)+items.length)%items.length].focus()});
  group.addEventListener('focusout',()=>requestAnimationFrame(()=>{if(!group.contains(document.activeElement))close(group)}));
  // A manual choice always wins over automatic detection
  group.addEventListener('submit',()=>store.set(localStorage,CHOSEN,'1'));
 });
 document.addEventListener('pointerdown',e=>{groups.forEach(g=>{if(!g.contains(e.target))close(g)})});
 document.addEventListener('keydown',e=>{if(e.key==='Escape')groups.forEach(g=>{if(g.querySelector('.nl-locale-trigger').getAttribute('aria-expanded')==='true')close(g,true)})});

 // First visit: follow Shopify's country/language suggestion for this visitor
 if(store.get(localStorage,CHOSEN)||store.get(sessionStorage,AUTO)||navigator.webdriver||/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent))return;
 store.set(sessionStorage,AUTO,'1');
 const countryForm=root.querySelector('.nl-locale-country'),languageForm=root.querySelector('.nl-locale-language');
 const option=(form,value)=>form&&value?form.querySelector('[data-locale-option][value="'+value+'"]'):null;
 fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',{headers:{Accept:'application/json'}})
  .then(r=>r.ok?r.json():null)
  .then(data=>{
   const parts=data&&data.suggestions&&data.suggestions[0]&&data.suggestions[0].parts;
   if(!parts)return;
   const country=parts.country&&parts.country.handle,language=parts.language&&parts.language.handle;
   const countryBtn=country!==root.dataset.country?option(countryForm,country):null;
   const languageBtn=language&&language.toLowerCase()!==root.dataset.language.toLowerCase()?option(languageForm,language):null;
   if(countryBtn){
    if(languageBtn)countryForm.querySelector('input[name=language_code]').value=languageBtn.value;
    countryForm.requestSubmit(countryBtn);
   }else if(languageBtn){
    languageForm.requestSubmit(languageBtn);
   }
  })
  .catch(()=>{});
})();
